import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import env from './env'
import remembered from './remembered'
import locations from './locations'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },

    mutations: {
    },

    actions: {
    },

    modules: {
        auth,
        remembered,
        env,
        locations
    }
})
